<p-toast position="top-right" />

<div class="shell">

  <!-- Sidebar desktop (statique) ────────────────────────────────────────── -->
  @if (!isMobile()) {
    <aside class="sidebar">
      <ng-container [ngTemplateOutlet]="sidebarContent"></ng-container>
    </aside>
  }

  <!-- Sidebar mobile (drawer avec backdrop) ─────────────────────────────── -->
  @if (isMobile()) {
    <p-drawer [(visible)]="drawerOpen" position="left" styleClass="mobile-drawer" [showCloseIcon]="true">
      <ng-container [ngTemplateOutlet]="sidebarContent"></ng-container>
    </p-drawer>
  }

  <ng-template #sidebarContent>
    <div class="sidenav-logo">
      <div class="logo-monogram">B</div>
      <div class="logo-text">
        <span class="logo-title">Bitha</span>
        <span class="logo-sub">Back Office</span>
      </div>
    </div>

    <nav class="nav-section">
      <p class="nav-label">Menu principal</p>
      @for (item of navItems; track item.route) {
        <a class="nav-item"
           [routerLink]="item.route"
           routerLinkActive="active-link"
           (click)="closeDrawerOnNav()">
          <i [class]="item.icon"></i>
          <span>{{ item.label }}</span>
        </a>
      }
    </nav>

    <div class="sidenav-footer">
      <p-avatar [label]="userInitials" shape="circle" styleClass="user-avatar" />
      <div class="user-meta">
        <span class="user-name">{{ userName }}</span>
        <span class="user-role-badge">Administrateur</span>
      </div>
      <button pButton type="button" class="logout-btn" icon="pi pi-sign-out"
              [text]="true" [rounded]="true" severity="secondary"
              (click)="logout()" pTooltip="Se déconnecter" tooltipPosition="top"></button>
    </div>
  </ng-template>

  <div class="content">

    <!-- Barre supérieure ─────────────────────────────────────────────────── -->
    <header class="toolbar">
      @if (isMobile()) {
        <button pButton type="button" icon="pi pi-bars" [text]="true" [rounded]="true"
                severity="secondary" (click)="toggleDrawer()"></button>
      }
      <span class="toolbar-spacer"></span>

      <!-- Notifications -->
      <p-overlaybadge [value]="unreadCount" [badgeDisabled]="unreadCount === 0" severity="danger" styleClass="notif-trigger">
        <button pButton type="button" icon="pi pi-bell" [text]="true" [rounded]="true"
                severity="secondary" (click)="openNotifications(notifPanel, $event)"
                pTooltip="Notifications" tooltipPosition="bottom"></button>
      </p-overlaybadge>

      <p-popover #notifPanel styleClass="notif-popover">
        <div class="notif-header">
          <span>Notifications</span>
          @if (notifications.length > 0) {
            <span class="notif-count">{{ notifications.length }}</span>
          }
        </div>

        @if (notifications.length === 0) {
          <div class="notif-empty">
            <i class="pi pi-bell-slash"></i>
            <p>Aucune notification</p>
          </div>
        } @else {
          <div class="notif-list">
            @for (notif of notifications.slice(0, 10); track $index) {
              <div class="notif-item" [class.unread]="!notif.read">
                <i [class]="'pi ' + notifService.metaFor(notif.type).icon" [style.color]="notifService.metaFor(notif.type).color"></i>
                <div class="notif-body">
                  <span class="notif-label">{{ notifService.metaFor(notif.type).label }}</span>
                  <span class="notif-message">{{ notif.message }}</span>
                </div>
              </div>
            }
          </div>
        }
      </p-popover>

      <!-- Profil -->
      <button pButton type="button" class="profile-trigger" [text]="true"
              (click)="profileMenu.toggle($event)">
        <p-avatar [label]="userInitials" shape="circle" size="normal" styleClass="topbar-avatar" />
        @if (!isMobile()) {
          <span class="profile-name">{{ userName }}</span>
          <i class="pi pi-angle-down"></i>
        }
      </button>
      <p-menu #profileMenu [model]="profileMenuItems" [popup]="true" appendTo="body"></p-menu>
    </header>

    <!-- Contenu de la page ───────────────────────────────────────────────── -->
    <main class="page-content">
      <router-outlet />
    </main>

  </div>

</div>
